class User{
  email = ''
  phoneNumber = ''
  phoneNumberCheck = ''
  photoURL = ''
  trustdockToken = ''
  trustdockId = ''
  trustdockResult = ''
  displayName = ''
  uid = ''
  facebookId = ''
  canvasImgURL = ''
  termsCheck = ''
  registComplete = ''
  bio = ''
  password = ''
  ids = {
    'yahoo_auction': {},
    'coconala': {},
    'anyca': {},
    'notteco': {},
    'spacemarket': {}
  }
}

class Users{
  users = []
  
  getMyUser = ()=>{
    return this.users[0];
  }
  setInit = ()=>{
    this.users = []
  }
  setMyUser = (user, callback)=>{
    
    if ("" !== user.uid && null !== user.uid && "undefined" !== typeof user.uid) {
      this.users[0].uid = user.uid
    }
    if ("" !== user.facebookId && null !== user.facebookId && "undefined" !== typeof user.facebookId) {
      this.users[0].facebookId = user.facebookId
    }
    if ("" !== user.email && null !== user.email && "undefined" !== typeof user.email) {
      this.users[0].email = user.email
    }
    if ("" !== user.displayName && null !== user.displayName && "undefined" !== typeof user.displayName) {
      this.users[0].displayName = user.displayName
    }
    if ("" !== user.photoURL && null !== user.photoURL && "undefined" !== typeof user.photoURL) {
      this.users[0].photoURL = user.photoURL
    }
    if ("" !== user.registComplete && null !== user.registComplete && "undefined" !== typeof user.registComplete) {
      this.users[0].registComplete = user.registComplete
    }
    callback()
  }
  setViwerUser = (user)=>{
    this.users[1] = user
  }
  getViwerUser = ()=>{
    if(this.users[1]){
      return this.users[1]
    }else{
      return {
        email:'',
        phoneNumber:'',
        photoURL:'',
        displayName:'',
        uid:'',
      }
    }
  }
   setCurrentUser = (user)=>{
    this.users[0] = user
  }
  setCurrentUserPass = (pass) => {
    this.users[0].password = pass
  }
   setCurrentUserID = (user)=>{
    this.users[0].uid = user.uid
  }
   setCurrentUserEmail = (email)=>{
    this.users[0].email = email
  }
   setPhoneNumber = (number)=>{
    this.users[0].phoneNumber = number
  }

   setCanvasurl = (canvasImgURL)=>{
    this.users[0].canvasImgURL = canvasImgURL
  }

   setOAuthRedirect = (user, callback)=>{
    if ("" !== user.firebase_uid && null !== user.firebase_uid && "undefined" !== typeof user.firebase_uid) {
      this.users[0].uid = user.firebase_uid
    }
    if ("" !== user.uid && null !== user.uid && "undefined" !== typeof user.uid) {
      this.users[0].facebookId = user.uid
    }
    if ("" !== user.email && null !== user.email && "undefined" !== typeof user.email) {
      this.users[0].email = user.email
    }
    if ("" !== user.displayName && null !== user.displayName && "undefined" !== typeof user.displayName) {
      this.users[0].displayName = user.displayName
    }
    if ("" !== user.photoURL && null !== user.photoURL && "undefined" !== typeof user.photoURL) {
      this.users[0].photoURL = user.photoURL
    }

    callback()
  }
  
}

let users = new Users()
users.users.push(new User())
//console.log(users);

setInterval(()=>{},1000)
export default users;


// WEBPACK FOOTER //
// ./src/store/user.js